export async function getAppVersion(): Promise<string | null> {
    return fetchRemoteVersion('default');
}

async function fetchRemoteVersion(cache: RequestCache, forceRefresh = false): Promise<string | null> {
    const cacheBuster = forceRefresh ? `?t=${Date.now()}` : '';

    try {
        const response = await fetch(`/app-version${cacheBuster}`, { cache });

        if (!response.ok) {
            return null;
        }

        const text = await response.text();
        const version = text.trim();
        return version.length > 0 ? version : null;
    } catch {
        return null;
    }
}

export async function getServerVersionCachedFirst(): Promise<{ cached: string | null; fresh: string | null }> {
    const cached = await fetchRemoteVersion('default');
    const fresh = await fetchRemoteVersion('no-store', true);
    return { cached, fresh };
}
